import styled, { css } from 'styled-components';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

export const Wrapper = styled.div`
  position: relative;
  background: ${(props) => props.theme.colors.greyLightest};
`;

export const ContainerInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media (min-width: ${(props) => props.theme.breakpoints.l}) {
    justify-content: flex-end;
  }
`;

const sharedStyles = ({ theme }) => css`
  position: relative;
  padding: 10px 0;
  color: ${theme.colors.greyDark};
  text-decoration: none;
  font-family: AdelleRegular;
  font-size: 14px;
  line-height: 20px;

  &:hover,
  &:focus {
    color: ${theme.colors.black};
  }

  &.active {
    color: ${theme.colors.black};

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background-color: ${theme.colors.brand};
    }
  }

  @media (min-width: ${theme.breakpoints.l}) {
    &:first-child {
      margin-right: 2em;
    }

    &:first-child:last-child {
      margin-right: 0;
    }
  }
`;

export const StyledLink = styled(AniLink)`
  ${sharedStyles}
`;

export const StyledLinkDummy = styled.span`
  ${sharedStyles}
`;
